import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundCloseOnMenuClick = this.closeOnMenuClick.bind(this)
    this.menuTarget.addEventListener("click", this.boundCloseOnMenuClick)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
    this.menuTarget.removeEventListener("click", this.boundCloseOnMenuClick)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    const menu = this.menuTarget
    menu.classList.remove("hidden")

    // If inside an overflow-hidden ancestor, switch to fixed positioning
    // so the menu isn't clipped by the container.
    const clipped = this.element.closest(".table-border-wrapper")
    if (clipped) {
      const rect = this.element.getBoundingClientRect()
      menu.style.position = "fixed"
      menu.style.top = `${rect.bottom + 4}px`
      menu.style.right = "auto"
      menu.style.left = `${rect.right - menu.offsetWidth}px`
      this._fixedPositioning = true
    }

    // Add click listener to close when clicking outside
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnClickOutside)
    }, 0)
  }

  close() {
    const menu = this.menuTarget
    menu.classList.add("hidden")

    // Restore original positioning
    if (this._fixedPositioning) {
      menu.style.position = ""
      menu.style.top = ""
      menu.style.right = ""
      menu.style.left = ""
      this._fixedPositioning = false
    }

    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnMenuClick(event) {
    const clickedItem = event.target.closest("a, button[type=submit]")
    if (clickedItem) {
      this.close()
    }
  }
}       